// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"468400a0","299":"468400a0","343":"468400a0","786":"468400a0","797":"468400a0","923":"468400a0"}[chunkId] + ".chunk.css";
};